import { jsx as _jsx } from "react/jsx-runtime";
import { createSvgIcon } from "@mui/material";
const DeleteColumn = createSvgIcon(
// From https://remixicon.com/ (https://github.com/Remix-Design/RemixIcon)
_jsx("path", { d: "M12 3C12.5523 3 13 3.44772 13 4L12.9998 11.9998C13.8355 11.372 14.8743 11 16 11C18.7614 11 21 13.2386 21 16C21 18.7614 18.7614 21 16 21C14.9681 21 14.0092 20.6874 13.2129 20.1518L13 20C13 20.5523 12.5523 21 12 21H6C5.44772 21 5 20.5523 5 20V4C5 3.44772 5.44772 3 6 3H12ZM11 5H7V19H11V5ZM19 15H13V17H19V15Z" }), "DeleteColumn");
export default DeleteColumn;
